export const OFFICE_HOURS_URL = 'https://cal.com/team/hatchet/talk-to-us';
export const DISCORD_INVITE_URL = 'https://discord.com/invite/ZMeUafwH89';
